module.exports = __webpack_public_path__ + "static/media/satellite~JtEKpLhg.0e6a726a.jpg";